<template>
    <div class="login-bgc">
        <div class="login-shell">
            <div class="login-brand">
                <div class="loginTitle">婺源县文旅大数据平台系统</div>
                <div class="login-subtitle">V1.0.0</div>
            </div>
            <div class="login-card">
                <div class="login-card-head">
                    <div>
                        <div class="login-card-title">账号登录</div>
                        <div class="login-card-subtitle">请输入账号密码进入系统</div>
                    </div>
                </div>
                <label class="login-main">
                    <span class="login-left">账号</span>
                    <input class="login-right" type="text" v-model="username" placeholder="请输入账号" autocomplete="username"/>
                </label>
                <label class="login-main">
                    <span class="login-left">密码</span>
                    <input class="login-right" type="password" v-model="password" placeholder="请输入密码" autocomplete="current-password"/>
                </label>
                <div class="login-btn" @click="loginOn">登录</div>
            </div>
        </div>
        <div class="login-message" v-show="isShow" :style="{background:bgcolor,color:color,borderColor:color}">{{content}}</div>
        <p class="bottom-tip">技术支持：广州市牵景科技有限公司</p>
    </div>
</template>
<script>
import { loginApi } from '../api/ScenicAPI';
export default {
    data(){
        return{
            username:'',
            password:'',
            content:'',
            isShow:false,
            bgcolor:"#fef0f0",
            color:'#f56c6c'
        }
    },
    methods:{
        loginOn(){
            if(this.username==''){
                this.content = '请输入账号'
                this.color = '#f56c6c'
                this.bgcolor = '#fef0f0'
                this.isShow = true
                let _this = this;
                setTimeout(function(){
                    _this.isShow = false
                },1000)
                return
            }
             if(this.password==''){
                this.content = '请输入密码'
                this.color = '#f56c6c'
                this.bgcolor = '#fef0f0'
                this.isShow = true
                let _this = this;
                setTimeout(function(){
                    _this.isShow = false
                },1000)
                return
            }
            loginApi({
                login_name:this.username,
                password:this.password,
            }).then(res => {
                console.log(res)
                this.$store.commit('setUserInfo',res.data.user_info);
                this.$store.commit('setScenicId',res.data.scenic_biz_id);
                this.$store.commit('setToken',res.data.token);
                sessionStorage.setItem('userInfo',res.data.user_info);
                 sessionStorage.setItem('scenicId',res.data.scenic_biz_id);
                sessionStorage.setItem('token',res.data.token);
                this.sessionStorage
                this.content = '登录成功'
                this.color = '#67c23a'
                this.bgcolor = '#f0f9eb'
                this.isShow = true
                let _this = this;
                setTimeout(function(){
                     _this.isShow = false
                     _this.$router.push({path:'/',query: {id:res.data.scenic_biz_id}})
                },1000)
            })
            
        }
    }
}
</script>

<style scoped>
.login-bgc{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 24px;
    box-sizing: border-box;
    min-height: 100vh;
    overflow: hidden;
    background: linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);
}
.login-bgc::before{
    content: "";
    position: absolute;
    inset: 0;
    background: url("../../static/img/big_data_bg.png") center center / cover no-repeat;
    opacity: .05;
    pointer-events: none;
}
.login-bgc::after{
    content: "";
    position: absolute;
    inset: 0;
    background:
        linear-gradient(90deg, rgba(64, 158, 255, .08) 1px, transparent 1px),
        linear-gradient(180deg, rgba(64, 158, 255, .08) 1px, transparent 1px);
    background-size: 44px 44px;
    mask-image: linear-gradient(180deg, rgba(0, 0, 0, .42), transparent 70%);
    pointer-events: none;
}
.login-shell{
    position: relative;
    z-index: 1;
    width: min(420px, 100%);
}
.login-brand{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 22px;
    user-select:none;
}
.login-logo{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    border: 1px solid rgba(64, 158, 255, .24);
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(31, 45, 61, .08);
}
.login-logo img{
    width: 24px;
    height: 24px;
    object-fit: contain;
}
.loginTitle{
    color: #1f2937;
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    letter-spacing: 0;
}
.login-subtitle{
    margin-top: 4px;
    color: #606266;
    font-size: 14px;
    line-height: 20px;
}
.login-card{
    padding: 28px;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 8px 24px rgba(31, 45, 61, .08);
}
.login-card-head{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 24px;
}
.login-card-title{
    color: #1f2937;
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
}
.login-card-subtitle{
    margin-top: 6px;
    color: #909399;
    font-size: 13px;
    line-height: 18px;
}
.login-main{
    display: block;
    margin-bottom: 18px;
    user-select:none;
}
.login-left{
    display: block;
    margin-bottom: 8px;
    color: #606266;
    font-size: 14px;
    line-height: 20px;
}
.login-right{
    display: block;
    padding:0 14px;
    box-sizing: border-box;
    width: 100%;
    height: 42px;
    border:1px solid #dcdfe6;
    border-radius: 6px;
    background: #f9fafc;
    color:#1f2937;
    font-size: 14px;
    line-height: 42px;
    outline: none;
    transition: border-color .2s ease, background-color .2s ease, box-shadow .2s ease;
}
.login-right::placeholder{
    color: #b4b8bf;
}
.login-right:focus{
    border-color: #409eff;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, .12);
}
.login-btn{
    margin-top: 26px;
    width: 100%;
    height: 42px;
    line-height: 42px;
    color: #fff;
    background-color: #409eff;
    text-align: center;
    border-radius: 6px;
    user-select:none;
    cursor: pointer;
    font-size: 15px;
    box-shadow: 0 8px 18px rgba(64, 158, 255, .22);
    transition: background-color .2s ease, box-shadow .2s ease, transform .2s ease;
}
.login-btn:hover{
    background-color: #337ecc;
    box-shadow: 0 10px 22px rgba(64, 158, 255, .28);
}
.login-btn:active{
    background-color: #2b70b8;
    transform: translateY(1px);
}
.login-message{
    display: inline-block;
    padding:0 18px;
    min-width: 260px;
    max-width: calc(100vw - 48px);
    box-sizing: border-box;
    position:absolute;
    z-index: 2;
    top:24px;
    left: 50%;
    transform: translate(-50%,0);
    height: 40px;
    line-height: 40px;
    border:1px solid #dcdfe6;
    border-radius: 4px;
    text-align: center;
    user-select:none;
    box-shadow: 0 8px 24px rgba(31, 45, 61, .08);
    font-size: 14px;
}
@media (max-width: 480px) {
    .login-bgc{
        padding: 28px 16px;
    }
    .login-card{
        padding: 24px 18px;
    }
    .loginTitle{
        font-size: 24px;
        line-height: 30px;
    }
}

.bottom-tip {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
  color: #000;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue